export default {
  /** 拠点情報をフェッチする */
  fetchEquipmentBaseStations({ commit }, payload) {
    commit("SET_EQUIPMENT_BASE_STATIONS", payload);
  },

  /** 資機材船舶情報をフェッチする */
  fetchEquipmentVessels({ commit }, payload) {
    commit("SET_EQUIPMENT_VESSELS", payload);
  },

  /** 資機材カテゴリマスタ情報をフェッチする */
  fetchEquipmentCategories({ commit }, payload) {
    commit("SET_EQUIPMENT_CATEGORIES", payload);
  },

  /** 出発岸壁マスタ情報をフェッチする */
  fetchEquipmentDepartureWharfs({ commit }, payload) {
    commit("SET_EQUIPMENT_DEPARTURE_WHARFS", payload);
  },

  /** 目的地マスタ情報をフェッチする */
  fetchEquipmentDestinations({ commit }, payload) {
    commit("SET_EQUIPMENT_DESTINATIONS", payload);
  },

  /** 投入実績情報をフェッチする */
  fetchEquipmentTypes({ commit }, payload) {
    commit("SET_EQUIPMENT_TYPES", payload);
  },

  /** 運搬航路マスタ情報をフェッチする */
  fetchEquipmentSeaRoutes({ commit }, payload) {
    commit("SET_EQUIPMENT_SEA_ROUTES", payload);
  },

  /** 削除された拠点情報を除外する */
  removeEquipmentBaseStations({ commit }, payload) {
    commit("REMOVE_EQUIPMENT_BASE_STATIONS", payload);
  },

  /** 削除された出発岸壁マスタ情報を除外する */
  removeEquipmentDepartureWharfs({ commit }, payload) {
    commit("REMOVE_EQUIPMENT_DEPARTURE_WHARFS", payload);
  },

  /** 削除された資機材船舶情報を除外する */
  removeEquipmentVessels({ commit }, payload) {
    commit("REMOVE_EQUIPMENT_VESSELS", payload);
  },

  /** 削除された資機材カテゴリマスタ情報を除外する */
  removeEquipmentCategories({ commit }, payload) {
    commit("REMOVE_EQUIPMENT_CATEGORIES", payload);
  },

  /** 削除された目的地マスタ情報を除外する */
  removeEquipmentDestinations({ commit }, payload) {
    commit("REMOVE_EQUIPMENT_DESTINATIONS", payload);
  },

  /** 削除された投入実績情報を除外する */
  removeEquipmentTypes({ commit }, payload) {
    commit("REMOVE_EQUIPMENT_TYPES", payload);
  },

  /** 削除された運搬航路マスタ情報を除外する */
  removeEquipmentSeaRoutes({ commit }, payload) {
    commit("REMOVE_EQUIPMENT_SEA_ROUTES", payload);
  },

  /*=========================================================================================
   リセット
  ==========================================================================================*/
  async resetVesselEquipmentBaseStationState({ commit }) {
    let defaultState = {
      equipmentBaseStations: [],
      equipmentVessels: [],
      equipmentTypes: [],
      equipmentCategories: [],
      equipmentDepartureWharfs: [],
      equipmentDestinations: [],
      equipmentSeaRoutes: [],
    };
    commit("RESET_STATE", defaultState);
  },
};
